(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('ViewPaymentsModalController', ViewPaymentsModalController);

    ViewPaymentsModalController.$inject = ['$uibModalInstance', 'InvoicesService', 'invoice'];

    function ViewPaymentsModalController($uibModalInstance, InvoicesService, invoice) {
        var vm = this;
        vm.invoice                  = invoice;
        vm.getInvoicePaymentHistory = getInvoicePaymentHistory;
        vm.cancel                   = cancel;

        activate();

        function activate() {
            vm.getInvoicePaymentHistory();
        }

        function getInvoicePaymentHistory() {
            vm.amountToBePaid = vm.invoice.total_calculated;
            if(vm.invoice.id) {
                InvoicesService.getInvoicePaymentHistory(vm.invoice.id).then(function (response) {
                    vm.invoicesPaymentsList = response.data;
                    if(response.data[0]) {
                        vm.amountToBePaid = vm.invoice.total_calculated - response.data[0].amount_to_be_paid;
                    }
                }).catch(function (err) {
                });
            }
        }

        function cancel() {
            $uibModalInstance.close();
        }
    }

})();